import * as Yup from "yup";

export const affiliationSchema = Yup.object().shape({
  organization_name: Yup.string().required("Organization name is required"),
  institution_id: Yup.string().required("Institution is required"),
  membership_status: Yup.string().nullable(),
});
